import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartPercentage',
  standalone: true
})
export class SmartPercentagePipe implements PipeTransform {

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '/';
    }

    let num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num)) {
      return '/';
    }

    let formatted = num.toFixed(2).replace(/\.?0+$/, '');

    return formatted + '%';
  }

}
